import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MyBookingPresModule } from '@app/my-booking/presenter/my-booking-pres.module';
import { MyBookingServiceService } from '@common/services/my-booking/my-booking-service/my-booking-service.service';
import { MyBookingStoreService } from '@common/services/my-booking/my-booking-store.service';
import { AswCommonStoreServiceModule } from '@lib/services';
import { AddLinkedModule } from '../sub-components/linked-modal/add-linked/add-linked.module';
import { LinkedModalModule } from '../sub-components/linked-modal/linked-modal.module';
import { MyBookingMenuModule } from '../sub-components/menu-modal/menu.module';
import { ModalSampleModule } from '../sub-components/modal-sample';
import { PassengerInformationInputModalModule } from '../sub-components/passenger-information-input-modal/passenger-information-input-modal.module';
import { MyBookingContComponent } from './my-booking-cont.component';

import { GetOrderStoreServiceModule } from '@common/services/my-booking/get-order-store/get-order-store.module';
import { HttpClientModule } from '@angular/common/http';
@NgModule({
  declarations: [MyBookingContComponent],
  imports: [
    CommonModule,
    AswCommonStoreServiceModule,
    MyBookingPresModule,
    PassengerInformationInputModalModule,
    AddLinkedModule,
    LinkedModalModule,
    MyBookingMenuModule,
    ModalSampleModule,
    HttpClientModule,
    GetOrderStoreServiceModule,
    RouterModule.forChild([{ path: '', component: MyBookingContComponent }]),
  ],
  providers: [MyBookingStoreService, MyBookingServiceService],
  exports: [MyBookingContComponent],
})
export class MyBookingContModule {}
